import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PromotionList = _resolveComponent("PromotionList")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_PromotionForm = _resolveComponent("PromotionForm")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, {
      class: "taxes-tabs",
      "tab-position": 'top',
      modelValue: _ctx.tabsValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabsValue = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('message.SERVICE_PROMOTION')
        }, {
          default: _withCtx(() => [
            (_ctx.serviceTab)
              ? (_openBlock(), _createBlock(_component_PromotionList, {
                  key: 0,
                  "promotion-type": "SERVICE"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_PromotionForm, { "promotion-type": _ctx.promotionType }, null, 8, ["promotion-type"])
  ], 64))
}